import SubtleBadge from '@/components/common/SubtleBadge';
import type { VolumeThresholds } from '../types';

type VolumeThresholdLegendProps = {
  thresholds?: VolumeThresholds | null;
};

/** Volume bucket legend for cluster-by-volume mode. */
export default function VolumeThresholdLegend({
  thresholds
}: VolumeThresholdLegendProps) {
  if (!thresholds) return null;
  const { lowMax, midMax } = thresholds;

  return (
    <div className="d-flex flex-wrap align-items-center gap-2">
      <span className="fs--2 text-600">محدوده میزان جستجو:</span>
      <SubtleBadge
        bg="success"
        className="d-inline-flex align-items-center gap-1 fs--2 px-2"
      >
        <span className="fw-semi-bold">جستجوی کم</span>
        <span className="opacity-75">≤ {lowMax}</span>
      </SubtleBadge>
      <SubtleBadge
        bg="warning"
        className="d-inline-flex align-items-center gap-1 fs--2 px-2"
      >
        <span className="fw-semi-bold">جستجوی متوسط</span>
        <span className="opacity-75">≤ {midMax}</span>
      </SubtleBadge>
      <SubtleBadge
        bg="danger"
        className="d-inline-flex align-items-center gap-1 fs--2 px-2"
      >
        <span className="fw-semi-bold">جستجوی زیاد</span>
        <span className="opacity-75">&gt; {midMax}</span>
      </SubtleBadge>
    </div>
  );
}
